import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const SentimentSatisfied = ({className, ...props}) => (
  _jsxs('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: [
    _jsx('circle', { cx: "15.5", cy: "9.5", r: "1.5",} )
    , _jsx('circle', { cx: "8.5", cy: "9.5", r: "1.5",} )
    , _jsx('path', { d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m0-4c-.73 0-1.38-.18-1.96-.52-.12.14-.86.98-1.01 1.15.86.55 1.87.87 2.97.87 1.11 0 2.12-.33 2.98-.88-.97-1.09-.01-.02-1.01-1.15-.59.35-1.24.53-1.97.53"                                  ,} )
  ]})
)

export default SentimentSatisfied
